import * as React from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';


class InfoModal extends React.Component {
    constructor(props) {
        super(props);
    }

    getAlignTextClass(alignText) {
        switch (alignText) {
            case 'center':
                return 'text-center';
            default:
                return '';
        }
    }

    render() {
        const {
            alignText,
            backdrop,
            className,
            hideBorder,
            isOpen,
            linkCancelLabel,
            linkContinueLabel,
            modalBody,
            modalFooter,
            modalNoFunction,
            modalWidth,
            modalYesFunction,
            NoParameter,
            showModalHeader,
            toggle,
            YesParameter
        } = this.props;
        const containerClass = "info-modal-container" +
            (alignText ? " " + this.getAlignTextClass(alignText) : "") +
            (modalWidth ? " info-modal-" + modalWidth : "") +
            (className ? " " + className : "");

        return (
            <Modal
                backdrop={backdrop}
                centered
                className={containerClass}
                contentClassName={hideBorder ? "modal-content--no-border" : ""}
                isOpen={isOpen}
                toggle={toggle ? () => toggle() : () => ({})}
            >
                {toggle && showModalHeader && <ModalHeader toggle={() => toggle()} />}
                <ModalBody>
                    <div className="row">
                        <div className="col-12">
                            {modalBody}
                        </div>
                    </div>
                </ModalBody>

                {modalFooter &&
                    <ModalFooter >
                        <div className="row">
                            <div className="col-12">
                                {modalFooter}
                            </div>
                        </div>
                    </ModalFooter>
                }

                {modalYesFunction && modalNoFunction && <>
                    <ModalFooter >
                        <div className="row footer-btn">
                            <div className="col-6">
                                <button type="button" className="btn btn-primary" onClick={() => modalYesFunction(YesParameter)}>{linkContinueLabel ? linkContinueLabel : "Yes"}</button>
                            </div>
                            <div className="col-6">
                                <button type="button" className="btn btn-primary" onClick={() => modalNoFunction(NoParameter)}>{linkCancelLabel ? linkCancelLabel : "No"}</button>
                            </div>
                        </div>
                    </ModalFooter>
                </>}
            </Modal>
        );
    }
}

InfoModal.defaultProps = {
    backdrop: true,
    hideBorder: false,
    showModalHeader: true
};

InfoModal.propTypes = {
    alignText: PropTypes.oneOf(['center']),
    backdrop: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.oneOf(['static'])
    ]),
    className: PropTypes.string,
    isOpen: PropTypes.bool.isRequired,
    hideBorder: PropTypes.bool,
    linkCancelLabel: PropTypes.string,
    linkContinueLabel: PropTypes.string,
    modalBody: PropTypes.object,
    modalFooter: PropTypes.object,
    modalNoFunction: PropTypes.func,
    modalWidth: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
    modalYesFunction: PropTypes.func,
    NoParameter: PropTypes.any,
    showModalHeader: PropTypes.bool,
    toggle: PropTypes.func,
    YesParameter: PropTypes.any
};

export default InfoModal;